import { isKshemaOnlyPolicy } from "./companyRules";

/**
 * How a policy's financier is labelled on the Preview / View / PDF. A KSHEMA-only policy asks just the name and the
 * Additional Details (KSHEMA's own boxes; the details are stored in `financierAddress`), so its address row says
 * "Additional Details" and an empty Type row is not shown. Every other policy reads as it always did.
 */
export const financierView = (policy) => {
  const kshemaOnly = isKshemaOnlyPolicy(policy);
  return {
    kshemaOnly,
    addressLabel: kshemaOnly ? "Additional Details" : "Financier Address",
    showType: !kshemaOnly || !!(policy && policy.financierType),
  };
};
